import { render, staticRenderFns } from "./ReferenceEdit.vue?vue&type=template&id=f10eb308&scoped=true&"
import script from "./ReferenceEdit.vue?vue&type=script&lang=js&"
export * from "./ReferenceEdit.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceEdit.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ReferenceEdit.vue?vue&type=style&index=1&id=f10eb308&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10eb308",
  null
  
)

export default component.exports